<app-navigation [@slideInOut]="menuState"></app-navigation>
<app-bread-crumbs></app-bread-crumbs>
<main>
  <h3 class="titler" *ngIf="auth.pageTitle">{{auth.pageTitle}}</h3>
  <router-outlet></router-outlet>
</main>